'use strict';

require("core-js/modules/es6.date.to-iso-string");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = formatAmazonDate;

function formatAmazonDate(date) {
  var sanitizedDate = new Date(date);

  if (isNaN(date)) {
    return null;
  }

  return sanitizedDate.toISOString().split('.')[0].replace(/[\-:.]/g, '') + 'Z';
}